import { z } from 'zod'

/**
 * Example shared validator. Validation functions and regexes live in
 * `lib/src/validators` so the API and web app enforce identical rules — the
 * client can pre-validate a form field with the same logic the server trusts.
 */
export const emailSchema = z.string().trim().toLowerCase().email()

export function isValidEmail(value: string): boolean {
  return emailSchema.safeParse(value).success
}
